var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"metrics-grid mb-8 mt-8"},_vm._l((_vm.visible_kpis),function(kpi){return _c('kpi-card',{key:kpi.label,attrs:{"kpi":kpi}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }